module.exports = __webpack_public_path__ + "static/media/partnership-background.f49c4cee.jpg";